import { useMutation } from "@tanstack/react-query";
import { parseResponse } from "lib/fetch";
import { sendContactRequest } from "lib/api/contact";

export const sendContact = (data: HashMap<unknown>) => parseResponse<unknown>(sendContactRequest(data));

export const useSendContact = () =>
    useMutation({
        mutationFn: (data: HashMap<unknown>) => sendContact(data),
    });
